module.exports = __webpack_public_path__ + "assets/Tau.724a30b77a9b2b123caf454f3221adf0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/packs1x/Tau.png
// module id = 799
// module chunks = 0